import { MapBounds } from "../models/map.bounds";
import { MapItinerary } from "../models/map.itinerary";
import { MapLatLng } from "../models/map.latlng";
import { FlexPolyline } from "./flex-polyline";
import { HMapComponent } from "./hmap.component";
import { HMapMarker } from "./hmap.marker";
import { HPolyline } from "./hmap.polyline";

declare var H: any;

export class HMapItinerary extends MapItinerary {
    private static instance?: HMapItinerary = undefined;
    private origen: any;
    private destino: any;
    private searchTimer: any;
    private searchPoints = new Map<string, any>();
    private hMap: HMapComponent;
    private polyline?: HPolyline;
    private markerOri?: HMapMarker;
    private markerDes?: HMapMarker;
    private markerSelec?: HMapMarker;
    private lastOri: string = '';
    private lastDes: string = '';
    private lastIndexSelec = -1;
    private lastBackgoundColor?: string;
    private result?: any;
    private searching = false;

    constructor(map: any, fromId: string, toId: string, fromPos: MapLatLng, toPos: MapLatLng, resultId: string,
        hMap: HMapComponent) {
        super(map, fromId, toId, resultId);
        HMapItinerary.instance = this;
        this.hMap = hMap;
        this.lastOri = this.hMap.translate('Origen');
        this.lastDes = this.hMap.translate('Destino');
        if (fromId && toId) {
            // Origen
            this.fromElem.addEventListener("keyup", (event: any) => {
                if (this.lastOri !== event.target.value) {
                    this.searchGeo(event.target);
                }
            });
            this.fromElem.addEventListener("change", (event: any) => {
                const point = this.searchPoints.get(event.target.value);
                document.getElementById(this.fromElem.nextElementSibling.id)!.innerHTML = '';
                this.lastOri = event.target.value;
                if (point !== undefined) {
                    this.origen = point;
                    if (this.destino) {
                        this.calcItinerary();
                        document.getElementById(this.fromElem.nextElementSibling.id)!.innerHTML = '';
                    }
                }
            });
            // Destino
            this.toElem.addEventListener("keyup", (event: any) => {
                if (this.lastDes !== event.target.value) {
                    this.searchGeo(event.target);
                }
            });
            this.toElem.addEventListener("change", (event: any) => {
                const point = this.searchPoints.get(event.target.value);
                document.getElementById(this.toElem.nextElementSibling.id)!.innerHTML = '';
                this.lastDes = event.target.value;
                if (point !== undefined) {
                    this.destino = point;
                    if (this.origen) {
                        this.calcItinerary();
                        document.getElementById(this.toElem.nextElementSibling.id)!.innerHTML = '';
                    }
                }
            });
        } else {
            this.setOrigen(fromPos);
            this.setDestino(toPos);
        }
    }

    searchGeo(input: any) {
        try {
            if (this.searchTimer !== null) {
                clearTimeout(this.searchTimer);
            }
            this.searchTimer = setTimeout(() => {
                let geocodingParameters: any = {
                    q: input.value,
                    lang: this.hMap.lang,
                    limit: 5
                }
                const sb = this.hMap.searchBounds.split(',');
                if (sb.length === 4) {
                    // Restrinjo el área de busqueda preferido
                    const lat0 = Number.parseFloat(sb[0]) + (Number.parseFloat(sb[2]) - Number.parseFloat(sb[0])) / 2;
                    const lng0 = Number.parseFloat(sb[1]) + (Number.parseFloat(sb[3]) - Number.parseFloat(sb[1])) / 2;
                    const radius = this.hMap.distanceGeo(Number.parseFloat(sb[0]), Number.parseFloat(sb[1]), lat0, lng0);
                    // in: 'countryCode:ESP,ITA,FRA', // Para limitar la búsqueda por paises
                    // at: this.map.getCenter().lat + ',' + this.map.getCenter().lng, // Para especificar las coordenadas alrededor
                    geocodingParameters.in = 'circle:' + lat0 + ',' + lng0 + ';r=' + Math.trunc(radius);
                } else {
                    geocodingParameters.at = this.map.getCenter().lat + ',' + this.map.getCenter().lng;
                }
                // El siguiente elemento es la lista de sitios encontrados
                const list: any = document.getElementById(input.nextElementSibling.id);
                let options = '';
                if (input.value.length > 0) {
                    // hMap.geoCoder.geocode(geocodingParameters, ((result: any) => {
                    this.hMap.geoCoder.autosuggest(geocodingParameters, ((result: any) => {
                        if (result) {
                            let words: string[] = [];
                            let words2: string[] = [];
                            result.items.forEach((item: any) => {
                                if (words.length < 1 && item.address && item.address.label) {
                                    words = item.address.label.replace(/,/g, ' ').split(' ');
                                    words2 = item.address.label.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/,/g, ' ').split(' ');
                                }
                            });
                            input.value = input.value.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
                            this.searchPoints.clear();
                            words.forEach((word: string, i: number) => {
                                if (word.length > 0) {
                                    input.value = input.value.replace(new RegExp(words2[i], 'gi'), words[i]);
                                }
                            });
                            result.items.forEach((item: any) => {
                                if (item.address && item.address.label && !this.searchPoints.get(item.address.label)) {
                                    options += '<option value="' + item.address.label + '" /> ';
                                    this.searchPoints.set(item.address.label, new H.geo.Point(item.position.lat, item.position.lng));
                                }
                            });
                            list.innerHTML = options;
                        }
                    }));
                }
            }, 500);
        } catch (e) {
            console.log(e);
        }
    }

    override setOrigen(pos: MapLatLng) {
        this.origen = new H.geo.Point(pos.lat, pos.lng);
    }

    override setDestino(pos: MapLatLng) {
        this.destino = new H.geo.Point(pos.lat, pos.lng);
    }

    override getOrigen(): MapLatLng {
        if (this.origen) {
            return new MapLatLng(this.origen.lat, this.origen.lng);
        }
        return null as any;
    }

    override getDestino(): MapLatLng {
        if (this.destino) {
            return new MapLatLng(this.destino.lat, this.destino.lng);
        }
        return null as any;
    }

    override async calcItinerary() {
        if (this.polyline) {
            this.polyline.remove();
            this.polyline = undefined;
        }
        if (this.markerOri) {
            HMapItinerary.instance!.hMap.removeMarker(this.markerOri);
            this.markerOri = undefined;
        }
        if (this.markerDes) {
            HMapItinerary.instance!.hMap.removeMarker(this.markerDes);
            this.markerDes = undefined;
        }
        if (this.markerSelec) {
            HMapItinerary.instance!.hMap.removeMarker(this.markerSelec);
            this.markerSelec = undefined;
        }
        if (HMapItinerary.instance!.origen && HMapItinerary.instance!.destino) {
            try {
                const http = this.hMap.http;
                this.result = await http!.get<any>(
                    'https://router.hereapi.com/v8/routes?' +
                    'apiKey=' + this.hMap.mapService.config?.hereApiKey +
                    '&origin=' + HMapItinerary.instance!.origen.lat + ',' + HMapItinerary.instance!.origen.lng +
                    '&destination=' + HMapItinerary.instance!.destino.lat + ',' + HMapItinerary.instance!.destino.lng +
                    '&transportMode=car&routingMode=fast' +
                    '&return=polyline,actions,travelSummary,instructions&lang=' + this.hMap.lang
                ).toPromise();
                if (this.result && this.result.routes && this.result.routes.length > 0) {
                    if (this.result.routes[0].sections && this.result.routes[0].sections.length > 0) {
                        const fpl = new FlexPolyline();
                        let res = fpl.decode(this.result.routes[0].sections[0].polyline);
                        if (res.polyline) {
                            let lat0 = 90;
                            let lng0 = 180;
                            let lat1 = 0;
                            let lng1 = -180;
                            this.polyline = new HPolyline(1, this.map, '#0000FF', 0.5, 5, this.hMap);
                            res.polyline.forEach((elem: any) => {
                                this.polyline?.addPoint(1, '', new MapLatLng(elem[0], elem[1]));
                                if (elem[0] < lat0) {
                                    lat0 = elem[0];
                                }
                                if (elem[1] < lng0) {
                                    lng0 = elem[1];
                                }
                                if (elem[0] > lat1) {
                                    lat1 = elem[0];
                                }
                                if (elem[1] > lng1) {
                                    lng1 = elem[1];
                                }
                            });
                            // Hago zoom de encuadre
                            HMapItinerary.instance!.hMap.fitTo(
                                new MapBounds(new MapLatLng(lat0, lng0), new MapLatLng(lat1, lng1))
                            );
                            // Pongo los marcadores de origen y destino
                            this.markerOri = new HMapMarker(0, this.lastOri!, 'A', this.lastOri!,
                                new MapLatLng(res.polyline[0][0], res.polyline[0][1]),
                                '', 99, HMapItinerary.instance!.map, false, true, 1, 22,
                                HMapItinerary.instance!.hMap, null);
                            this.markerOri.setAnchor('assets/images/redmarker.png', 32, 32, 16, 32);
                            this.markerDes = new HMapMarker(0, this.lastDes!, 'B', this.lastDes!,
                                new MapLatLng(res.polyline[res.polyline.length - 1][0],
                                    res.polyline[res.polyline.length - 1][1]),
                                '', 99, HMapItinerary.instance!.map, false, true, 1, 22,
                                HMapItinerary.instance!.hMap, null);
                            this.markerDes.setAnchor('assets/images/redmarker.png', 32, 32, 16, 32);
                        }
                        const hh = Math.trunc(this.result.routes[0].sections[0].travelSummary.duration / 3600);
                        const mm = Math.trunc((this.result.routes[0].sections[0].travelSummary.duration - hh * 3600) / 60);
                        let i = 0;
                        let instrucciones = '<div>';
                        instrucciones += '<div id="lineaIti-' + i + '" style="float: left; padding-left: 4px; line-height: 30px; background-color: lightgray; width: 100%; height: 30px;">' +
                            this.lastOri +
                            '</div></div><hr style="float: left; margin: 0px; width: 100%;">';
                        i++;
                        instrucciones +=
                            '<div id="lineaIti-' + i + '" style="float: left; padding-left: 4px; line-height: 30px; background-color: white; width: 100%; height: 30px;">' +
                            Math.trunc(this.result.routes[0].sections[0].travelSummary.length / 1000) + ' Km. ' +
                            (hh > 0 ? hh + ' h ' : '') + (mm > 0 ? mm + ' min, ' : ', ') +
                            this.hMap.translate('Aproximadamente').toLowerCase() +
                            '</div></div><hr style="float: left; margin: 0px; width: 100%;">';
                        i++;
                        if (this.result.routes[0].sections[0].actions) {
                            this.result.routes[0].sections[0].actions.forEach((elem: any) => {
                                let icono = undefined;
                                switch (elem.action) {
                                    case 'turn': // Giro
                                        if (elem.direction === 'right') {
                                            if (elem.severity === 'quite') {
                                                icono = 'assets/images/iti/gira-dch.png';
                                            } else {
                                                icono = 'assets/images/iti/gira-lig-dch.png';
                                            }
                                        } else {
                                            if (elem.severity === 'quite') {
                                                icono = 'assets/images/iti/gira-izq.png';
                                            } else {
                                                icono = 'assets/images/iti/gira-lig-izq.png';
                                            }
                                        }
                                        break;
                                    case 'roundaboutExit': // Rotonda
                                        icono = 'assets/images/iti/rotonda.png';
                                        break;
                                    case 'continue': // Continuar
                                        icono = 'assets/images/iti/siga.png';
                                        break;
                                    case 'keep': // Mantenerse en un carril
                                        if (elem.direction === 'right') {
                                            icono = 'assets/images/iti/manten-dch.png';
                                        } else {
                                            icono = 'assets/images/iti/manten-izq.png';
                                        }
                                        break;
                                    case 'ramp': // Entrada a autovía
                                    case 'exit': // Salida de autovía
                                        if (elem.direction === 'right') {
                                            icono = 'assets/images/iti/salida-dch.png';
                                        } else {
                                            icono = 'assets/images/iti/salida-izq.png';
                                        }
                                        break;
                                }
                                instrucciones += icono ? '<img src="' + icono + '" style="float: left;" width="24" height="24">' :
                                    '<div style="float: left; width: 24px;">&nbsp;</div>';
                                instrucciones += '<div id="lineaIti-' + i + '" style="float: left; line-height: 30px; padding-left: 5px; background-color: white; width: 90%; height: 30px;">' +
                                    (i - 1) + '. ' + elem.instruction + '</div><hr style="float: left; margin: 0px; width: 100%;">';
                                i++;
                            });
                        }
                        instrucciones += '<div id="lineaIti-' + i + '" style="float: left; padding-left: 4px; line-height: 30px; background-color: lightgray; width: 100%; height: 30px;">' +
                            this.lastDes + '</div></div>';
                        HMapItinerary.instance!.resultElem.innerHTML = instrucciones;
                        while (i > -1) {
                            const linea = document.getElementById('lineaIti-' + i);
                            if (linea) {
                                const index = i;
                                linea.addEventListener('click', event => {
                                    this.onClickRoute(index);
                                });
                            }
                            i--;
                        }
                    }
                }
            } catch (e) {
                console.log(e);
            }
        }
    }

    onClickRoute(index: number) {
        if (this.lastIndexSelec > -1) {
            const oldLine: any = document.getElementById('lineaIti-' + this.lastIndexSelec);
            if (oldLine) {
                oldLine.style.backgroundColor = this.lastBackgoundColor;
            }
        }
        const linea = document.getElementById('lineaIti-' + index);
        if (linea) {
            this.lastIndexSelec = index;
            this.lastBackgoundColor = linea.style.backgroundColor;
            linea.style.backgroundColor = 'lightgray';
            if (index < 2) {
                index = 2;
            } else {
                if (index >= this.result.routes[0].sections[0].actions.length + 2) {
                    index = this.result.routes[0].sections[0].actions.length + 1;
                }
            }
            const i = this.result.routes[0].sections[0].actions[index - 2].offset;
            const point = this.polyline?.points[i];
            if (this.markerSelec) {
                HMapItinerary.instance!.hMap.removeMarker(this.markerSelec);
            }
            this.markerSelec = new HMapMarker(0, this.result.routes[0].sections[0].actions[index - 2].instruction, '',
                this.result.routes[0].sections[0].actions[index - 2].instruction,
                new MapLatLng(point!.point.lat, point!.point.lng), 'assets/images/bluemarker.png', 999,
                HMapItinerary.instance!.map, false, true, 1, 22,
                HMapItinerary.instance!.hMap, null);
            this.map.setCenter(new MapLatLng(point!.point.lat, point!.point.lng));
            this.markerSelec.setAnchor('assets/images/bluemarker.png', 32, 32, 16, 32);
        }
    }

    override remove() {
        if (this.markerOri) {
            this.hMap.removeMarker(this.markerOri);
        }
        if (this.markerDes) {
            this.hMap.removeMarker(this.markerDes);
        }
        if (this.markerSelec) {
            this.hMap.removeMarker(this.markerSelec);
        }
        if (this.polyline) {
            this.hMap.removePolyline(this.polyline);
        }
        this.resultElem.innerHTML = '';
    }
}
